export const NOT_ACTIVE =
  "You must have joined a Battle within the last year to see this page. If you recently joined, please try logging out then logging back in again. If you have joined a Battle and that still doesn't work, then please email admin@writingbattle.com";
